export default __webpack_public_path__ + "static/media/1962.34d1ad24.png";